import Vue from 'vue'
import Vuex from 'vuex'

import {Registration} from '../models/registration.js'
import {Organization} from '../models/organization.js'
import {Account}      from '../models/account.js'
import reg_store from './modules/registration'

Vue.use(Vuex)

//https://www.youtube.com/watch?v=iw1eajzWQAM
// using ...
// check mapGetters
//to watch https://www.youtube.com/watch?v=dkFWOsKrPAI
export const store = new Vuex.Store({
    state: { // keyword to set variables
      current_user: {organizations: []},
      current_org: new Organization(),
      current_account: new Account(),
      current_reg: new Registration(),
      counter: Date.now(),
      current_user_promise: null,
      current_org_promise: {},
      unsaved_changes_alert_show: false,
      unsaved_changes_alert_method: function(){},
      selectedItem: null,
    },
    getters:{
      current_user(state){
          return state.current_user
      },
      current_org(state){
          return state.current_org
      },
      current_account(state){
          return state.current_account
      },
    },
    modules: {
      reg_store
    },
    mutations: {
        logout (state) {
            state.current_user = {organizations: []}
        },
        login(state, payload){
          state.current_user = payload
          state.current_user.current_org_id = payload.current_org_id
          Vue.axios.defaults.headers.common['Access-Token'] = payload.access_token
          window.time_zone = payload.time_zone||"America/New_York"
        },
        setOrg(state, payload){
          state.current_org = new Organization(payload)
        },
        unloadReg(state){
          state.current_reg = new Registration()
          state.reg_store.cache= {}
        },
        setSelectedItem(state, item) {
          state.selectedItem = item;
        },
    },
    actions: {
      login({commit,state}){
        if (state.current_user_promise) return state.current_user_promise
        state.current_user_promise =  Vue.axios.get('/users/current', {params: {vue: 1}})
        state.current_user_promise.then(resp => {
            commit('login',resp.data)
            return resp.data
        })
        return state.current_user_promise
      },
      loadOrg({commit, dispatch, state}, include=[]){
        const key = JSON.stringify(include)

        // if (!state.current_org_promise[key]){
            state.current_org_promise[key] = dispatch('login').then(()=>{
              if (state.current_user.current_org_id){
                return Vue.axios.get(
                  `/api2/organization/organizations/${state.current_user.current_org_id}`,
                  {params: {include: include}}
                )
              }else{
                return Promise.reject({})
              }
            })
        // }

        state.current_org_promise[key].then(resp => {
          commit('setOrg',resp.data.object)
          return resp.data
        })
        return state.current_org_promise[key]
      },
      reLoadUser({dispatch,state}){
        delete state.current_user_promise
        return dispatch('login')
      },
      reLoadOrg({dispatch,state}, include=[]){
        const key = JSON.stringify(include)
        delete state.current_org_promise[key]
        return dispatch('loadOrg', include)
      }
    }
})
